const post = async (path, body) => {
  const response = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }
  if (!response.ok) {
    const error = new Error(data?.error || "Memory request failed");
    error.payload = data;
    error.status = response.status;
    throw error;
  }
  return data;
};

export const memoryPresence = (userId, displayName, looking) =>
  post("/api/memory/presence", { userId, displayName, looking: Boolean(looking) });

export const memorySelect = (userId, displayName, opponentId) =>
  post("/api/memory/select", { userId, displayName, opponentId });

export const memoryLeave = (userId) => {
  if (!userId) return Promise.resolve();
  return post("/api/memory/leave", { userId }).catch(() => {});
};
